export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-clapperboard-line text-background-50 text-base"></i>
              </span>
              <span className="text-lg font-heading text-foreground-950">樱花动漫</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              樱花动漫网提供海量免费动漫全集，涵盖热门完结动漫类型，支持在线观看，每日更新好看的动漫资源，轻松追番。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-950 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">动漫索引</a>
              <a href="#ranking" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">热门排行</a>
              <a href="#topics" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">热门话题</a>
              <a href="#updates" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">更新动态</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-950 mb-4">关于</h4>
            <div className="space-y-2.5">
              <a href="#about" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</a>
              <a href="#faq" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">投稿合作</a>
              <a href="#features" className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">平台特色</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-foreground-950 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-400 leading-relaxed">
              感谢所有合作伙伴的支持与信任。诚邀更多动漫内容创作者与平台加入合作。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2018-2026 樱花动漫网 sakura-anime.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">用户协议</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" onClick={(e) => e.preventDefault()} className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}